import styled from "@emotion/styled";
import { Card, Theme } from "@mui/material";

export const StyledCard = styled(Card)<{
  theme: Theme;
}>((props) => ({
  display: "inline-block",
//   border: "rgba(0,0,0,0.5) solid 1px",
  margin: props.theme.spacing(1),
//   borderRadius: "10px",
  minHeight: "371px",
}));

export const StyledImg = styled.img((props) => ({
    borderRadius: "10px",
    objectFit: "cover",
    '&:hover':{
        transform: "scale(1.2)",
        transition: "transform 0.3s ease-in-out"
    }
}))